import { type BenchmarkEntry } from "@/types/SharedTypes";
import { createContext, useContext } from "react";

export type ScanResultType = {
    qrOne?: string;
    qrTwo?: string;
    serial?: string;
}
interface BenchmarkContextType {
    scanResults: ScanResultType
    entries: BenchmarkEntry[];
    startTime?: number | null;
    endTime?: number | null;
    addBenchmarkEntry: (entry: BenchmarkEntry) => void;
    startBenchmark: () => void;
    stopBenchmark: () => void;
    getElapsedTimeMs: () => number;
    captureScanResult: (result: ScanResultType) => void;
}

export const BenchmarkContext = createContext<BenchmarkContextType>({
    scanResults: {},
    entries: [],
    startTime: null,
    endTime: null,
    addBenchmarkEntry: () => { },
    startBenchmark: () => { },
    stopBenchmark: () => { },
    getElapsedTimeMs: () => 0,
    captureScanResult: () => { },
    
});

export const useBenchmark = () => useContext(BenchmarkContext);